import { useState } from 'react';

interface DrawerProps {
  survey: boolean;
  onBoarding: boolean;
  cfs: boolean;
  frop: boolean;
  showDetail: boolean;
}

export const useLearnerResult = () => {
  const [drawer, setDrawer] = useState<DrawerProps>({
    survey: false,
    onBoarding: false,
    cfs: false,
    frop: false,
    showDetail: false,
  });

  const handleOpenDrawer = (key: keyof DrawerProps, detail: boolean = false) => {
    setDrawer({
      ...drawer,
      [key]: true,
      showDetail: detail,
    });
  };

  const handleCloseDrawer = (key: keyof DrawerProps) => {
    setDrawer({
      ...drawer,
      [key]: false,
    });
  };

  return {
    drawer,
    handleOpenDrawer,
    handleCloseDrawer,
  };
};
